import type { Course } from "@brookbush/types";

const CourseTargetAudience = ({
	targetAudience,
}: {
	targetAudience: Course["targetAudience"];
}) => {
	if (!targetAudience) return null;

	return (
		<div className="mx-auto flex flex-col items-center gap-4 sm:gap-6">
			<h2 className="font-semibold text-2xl sm:text-2xl">Target Audience</h2>

			<div className="flex flex-wrap justify-center gap-3.5">
				{targetAudience?.map((item) => (
					<div
						className="whitespace-nowrap rounded-full bg-slate-100 px-2.5 py-1 font-medium sm:px-3.5 sm:py-1 dark:bg-slate-700"
						key={item}
					>
						{item}
					</div>
				))}
			</div>
		</div>
	);
};

export default CourseTargetAudience;
